// extracted by mini-css-extract-plugin
export var coralReef = "CountdownBanner-module--coralReef--cb87d";
export var countdownBanner = "CountdownBanner-module--countdownBanner--7fb81";
export var countdownBannerCountdown = "CountdownBanner-module--countdownBannerCountdown--34142";
export var countdownBannerDisplay = "CountdownBanner-module--countdownBannerDisplay--9b233";
export var countdownBannerMessage = "CountdownBanner-module--countdownBannerMessage--1028b";
export var countdownBannerText = "CountdownBanner-module--countdownBannerText--07961";
export var pinkOrchid = "CountdownBanner-module--pinkOrchid--0a06c";
export var seaFoam = "CountdownBanner-module--seaFoam--40dd7";